import { createReducer, on } from '@ngrx/store';
import { GMBActions } from '@actions/index';
import { GoogleBusiness } from '@models/index';

export { GoogleBusiness };
export type NotAuthenticated = false;
export type NotFetched = null;

export interface State {
  // Business[] == array of user's GMB businesses. may be empty (if they have none on Google's end)
  // false == back-end indicates the user is not authenticated with GMB
  // null == we haven't fetched businesses from back-end, or in-progress
  businesses: GoogleBusiness[] | NotAuthenticated | NotFetched;
  error: {
    message: string | null,
    error: any | null
  } | null;
  isExecutingTask: boolean;
}

const initialState: State = {
  businesses: null,
  error: null,
  isExecutingTask: false,
}

const reduceStartTask = (state: State, _) => ({
  ...state,
  isExecutingTask: true,
});

export const reducer = createReducer<State>(
  initialState,
  on(GMBActions.reset, _ => ({ ...initialState })),
  on(GMBActions.error, (state, error) => ({
    ...state,
    error: {
      message: error ? error.message : null,
      error: error ? error.cause : null
    },
    isExecutingTask: false,
  })),
  on(GMBActions.searchGoogleBusinessesByCurrentUser, reduceStartTask),
  on(GMBActions.searchGoogleBusinessesByCurrentUserSuccess, (state: State, { businesses }) => ({
    ...state,
    businesses: businesses,
    isExecutingTask: false,
  })),
  on(GMBActions.authenticateWithGoogle, reduceStartTask),
  on(GMBActions.refreshBusinesses, reduceStartTask),
);

export const getError = (state: State) => state.error;
export const getBusinesses = (state: State) => state.businesses;
export const getIsExecutingTask = (state: State) => state.isExecutingTask;
